import { createAsyncThunk } from '@reduxjs/toolkit';
import { OnBoardingFlowType, OnBoardingScreenOptions } from '@mindly/ui-components';
import { getOnBoardingFlowById } from '../../api/onBoardingFlow';
import { ApiResponseType } from '../../shared';
import { getAreasOfWorkByClientProblem } from 'src/api/areasOfWork';
import { setLocalizedAreasOfWorkByClientProblem } from './reducer';

export const fetchOnBoardingFlow = createAsyncThunk(
  'onBoardingFlow/fetch',
  async (params: { id: string; isTestMode?: boolean }, { rejectWithValue, dispatch }) => {
    try {
      const response = await getOnBoardingFlowById(params.id, params.isTestMode);

      const hasGoalScreen = Object.values(response.data.screens).some(
        (screen) => screen.type === OnBoardingScreenOptions.GOAL
      );

      if (hasGoalScreen) {
        const areasOfWorkByClientProblem = await getAreasOfWorkByClientProblem({
          lang: response.data.locale,
          showEmptyCategories: true,
          isLocalizedAreasOfWorkByClientProblem: true,
        });
        dispatch(setLocalizedAreasOfWorkByClientProblem(areasOfWorkByClientProblem ?? []));
      }

      return response;
    } catch (e) {
      const data = e as ApiResponseType<OnBoardingFlowType>;
      return rejectWithValue(data?.error?.[0]?.msg ? data.error[0].msg : 'Error fetching onboarding flow');
    }
  }
);

export const fetchNewDataOnBoardingFlow = createAsyncThunk(
  'onBoardingFlow/fetch-new-data',
  async (params: { id: string; isTestMode?: boolean }, { rejectWithValue, dispatch }) => {
    try {
      const response = await getOnBoardingFlowById(params.id, params.isTestMode);

      const hasGoalScreen = Object.values(response.data.screens).some(
        (screen) => screen.type === OnBoardingScreenOptions.GOAL
      );

      if (hasGoalScreen) {
        const areasOfWorkByClientProblem = await getAreasOfWorkByClientProblem({
          lang: response.data.locale,
          showEmptyCategories: true,
          isLocalizedAreasOfWorkByClientProblem: true,
        });
        dispatch(setLocalizedAreasOfWorkByClientProblem(areasOfWorkByClientProblem ?? []));
      }

      return response;
    } catch (e) {
      const data = e as ApiResponseType<OnBoardingFlowType>;
      return rejectWithValue(data?.error?.[0]?.msg ? data.error[0].msg : 'Error fetching onboarding flow');
    }
  }
);
